module.exports = __webpack_public_path__ + "static/media/search-black.20eb2e92.svg";